import {
	List,
	ListItemButton,
	Stack,
	Typography,
	useTheme,
} from "@mui/material";
import { Check } from "lucide-react";
import type { FlatRowSelectOption } from "web_myplann/Shared/Components/FlatRow/FlatRowSelect";

type Props<TValue extends string | number = string> = {
	options: FlatRowSelectOption<TValue>[];
	value: TValue[];
	onSelect: (value: TValue) => void;
};

const CHECK_STROKE_WIDTH = 2.5;

export const FlatRowSelectOptionList = <
	TValue extends string | number = string,
>({
	options,
	value,
	onSelect,
}: Props<TValue>) => {
	const theme = useTheme();

	return (
		<List disablePadding sx={{ px: theme.spacingTokens.lg }}>
			{options.map((option, index) => {
				const isSelected = value.some(
					(selected) => String(selected) === String(option.value),
				);
				return (
					<ListItemButton
						key={String(option.value)}
						onClick={() => onSelect(option.value)}
						sx={{
							px: 0,
							py: theme.spacingTokens.md,
							borderBottom:
								index === options.length - 1
									? "none"
									: theme.colors.border.solid(theme.palette.grey[100]),
						}}
					>
						<Stack
							direction="row"
							alignItems="center"
							justifyContent="space-between"
							gap={theme.spacingTokens.md}
							width="100%"
						>
							<Typography
								variant={isSelected ? "bodyStrong" : "body2"}
								color={
									isSelected ? theme.palette.blue.main : theme.palette.grey[900]
								}
							>
								{option.label}
							</Typography>
							{isSelected && (
								<Check
									size={theme.iconSize.md}
									color={theme.palette.blue.main}
									strokeWidth={CHECK_STROKE_WIDTH}
								/>
							)}
						</Stack>
					</ListItemButton>
				);
			})}
		</List>
	);
};
